export enum DeviceProviderType {
    Fitbit = 'FITBT',
    Misfit = 'MISFT',
    Garmin = 'GRMIN',
    Strava = 'STRAV'
}
